/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReleaseUpgradePath } from './releaseUpgradePath';
import { UpgradeDeploymentStatusEnum } from './upgradeDeploymentStatusEnum';
import { EC2InstancesInfo } from './eC2InstancesInfo';
import { ReleaseRegionData } from './releaseRegionData';


export interface UpgradeCheckResult { 
    id: string;
    status: UpgradeDeploymentStatusEnum;
    /**
     * true if the list of upgrade paths contains a default upgrade path
     */
    default_path_exist: boolean;
    instances_info: EC2InstancesInfo;
    /**
     * List of upgrade paths for a deployment
     */
    upgrade_paths: Array<ReleaseUpgradePath>;
    current_deployment_info: Array<ReleaseRegionData>;
}
export namespace UpgradeCheckResult {
}


